import React, { Component } from "react";

const ServiceList = [
    {
        icon: '01',
        title: 'Web Development',
        description: 'Beautiful, blazing fast, and built to last. We build clean, efficient, and high performance websites and web apps.'
    },
    {
        icon: '02',
        title: 'Mobile Development',
        description: 'If you\'re not on mobile, you\'re not on the internet. Responsive web, native iOS, or native Android. We got you.'
    },
    {
        icon: '03',
        title: 'Digital Strategy',
        description: 'Tech is complicated. Let our decades of experience guide you to solutions that drive real value for your business.'
    },
]

class ServiceOne extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceList.map( (val , i) => (
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                            <div className="service service__style--1">
                                <div className="icon">
                                    <img src={`/assets/images/icons/icon-${val.icon}.png`} alt="Digital Agency"/>
                                </div>
                                <div className="content">
                                    <h4 className="title">{val.title}</h4>
                                    <p>{val.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceOne;